/*
 * @Author       : zhangbobo01 zhangbobo01@baidu.com
 * @Date         : 2022-11-17 21:06:48
 * @LastEditors  : zhangbobo01 zhangbobo01@baidu.com
 * @LastEditTime : 2023-02-13 18:18:08
 * @FilePath     : /ticket-plat-frontend/src/common/constants.ts
 */
import i18n from '@/i18n';
import type {AllowedButtons, PopoverDOM} from 'driver.js';

export enum PERMISSION {
    FULL_CONTROL = 'FULL_CONTROL', // 读写账号下全部工单
    USER_CONTROL = 'USER_CONTROL', // 读写登录子用户id下全部工单
    DENY = 'DENY', // 禁止访问
    INITIAL = 'INITIAL', // 初始状态
}

export enum LOCAL {
    en = 'en',
    zh = 'zh-CN',
}

export const TICKET_STATUS = [
    {value: 'HANDLING', text: i18n.t('chu-li-zhong')},
    {value: 'WAITING_FOR_FEEDBACK', text: i18n.t('dai-fan-kui')},
    {value: 'WAITING_FOR_CONFIRM', text: i18n.t('dai-que-ren')},
    {value: 'FINISHED', text: i18n.t('yi-wan-cheng')},
    {value: 'CANCELED', text: i18n.t('yi-che-xiao')},
];

export const TICKET_STATUS_FOR_ICON_MAP = {
    HANDLING: 'process',
    CANCELED: 'waiting',
    FINISHED: 'success',
    WAITING_FOR_FEEDBACK: 'warning',
    WAITING_FOR_CONFIRM: 'warning',
};

export const FINISHED_STATUS = [
    'FINISHED',
    'CANCELED',
];

export const UPLOAD_FILE_TYPES = [
    'jpg',
    'png',
    'jpeg',
    'bmp',
    'gif',
    'pdf',
    'txt',
    'log',
    'doc',
    'docx',
    'ini',
    'conf',
    'eml',
    'xls',
    'xlsx',
    'rar',
    'zip',
    '7z',
    'mp4',
];

export const UPLOAD_IMAGE_TYPES = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];

export const CUSTOMER_PRIORITY = ['C0', 'C1', 'C2', 'C3'];

export const AREAS_MAP: any = {
    bj: {id: 'bj', text: i18n.t('hua-bei-bei-jing')},
    bd: {id: 'bd', text: i18n.t('hua-bei-bao-ding')},
    cd: {id: 'cd', text: i18n.t('xi-nan-cheng-du')},
    gz: {id: 'gz', text: i18n.t('hua-nan-guang-zhou')},
    su: {id: 'su', text: i18n.t('hua-dong-su-zhou')},
    fsh: {id: 'fsh', text: i18n.t('hua-dong-shang-hai')},
    fwh: {id: 'fwh', text: i18n.t('jin-rong-hua-zhong-wu-han')},
    hkg: {id: 'hkg', text: i18n.t('zhong-guo-xiang-gang')},
    sin: {id: 'sin', text: i18n.t('xin-jia-po')},
};

export const INSTANCE_BACK_UP_TYPES = [
    {value: 'FINISHED', label: i18n.t('yi-wan-cheng-bei-fen')},
    {value: 'ACKNOWLEDGED', label: i18n.t('wei-wan-cheng-bei-fen-feng-xian-yi-zhi-xiao')},
];

export const AUTH_OPERATIONS = [
    {value: 'VIEW', label: i18n.t('xin-xi-du-qu'), text: i18n.t('xin-xi-du-qu')},
    {value: 'REBOOT', label: i18n.t('zhong-qi'), text: i18n.t('zhong-qi')},
    {value: 'RESET_PASSWORD', label: i18n.t('zhong-zhi-mi-ma'), text: i18n.t('zhong-zhi-mi-ma')},
    {value: 'MODIFY_CONFIG', label: i18n.t('xiu-gai-pei-zhi'), text: i18n.t('xiu-gai-pei-zhi')},
    {value: 'OPERATION', label: i18n.t('cao-zuo-quan-xian'), text: i18n.t('cao-zuo-quan-xian')},
];

export const AUTH_STATUS = [
    {value: 'INIT', text: i18n.t('dai-shou-quan'), tooltip: i18n.t('shou-quan-shen-qing-shang-wei-chu-li')},
    {value: 'AUTHORIZED', text: i18n.t('sheng-xiao-zhong'), tooltip: i18n.t('shou-quan-zai-you-xiao-qi-nei')},
    {value: 'EXPIRED', text: i18n.t('yi-shi-xiao'), tooltip: i18n.t('shou-quan-yi-chao-chu-you-xiao-qi')},
    {value: 'REJECTED', text: i18n.t('yi-ju-jue'), tooltip: i18n.t('shou-quan-yi-ju-jue')},
    {value: 'STOPPED', text: i18n.t('yi-ting-zhi'), tooltip: i18n.t('shou-quan-yi-ti-qian-zhong-zhi')},
];

export const AUTH_STATUS_FOR_ICON_MAP = {
    INIT: 'warning',
    AUTHORIZED: 'success',
    EXPIRED: 'waiting',
    REJECTED: 'waiting',
    STOPPED: 'waiting',
};

export const SNAP_SHOT_TYPES = {
    system: i18n.t('xi-tong-pan-kuai-zhao'),
    cds: i18n.t('shu-ju-pan-kuai-zhao'),
};
// 消息类型
export enum MSG_TYPE {
    // 附件消息：只有附件
    ATTACHMENTS = 'ATTACHMENTS',
    // 代码消息
    CODE = 'CODE',
    FB_ORDER = 'FB_ORDER', // 订单信息
}

// LS镜像类型
export const LS_IMAGE_TYPE = {
    ls_template: '自定义',
    lightserver_image: '应用型',
    image: '系统',
};

// 常用工具图标
// OPT: 临时方案，后续需要优化
export const FAVOR_TOOL_ICON_MAP = {
    default: 'bac-icon-tools',
    '示例代码中心': 'bac-icon-code-preview',
    'AI应用详情': 'bac-icon-app-detail',
    '在线错误码查询': 'bac-icon-search-text',
    'BCC健康检查工具': 'bac-icon-service-healthy',
    'BCC端口验通工具': 'bac-icon-port',
    '网站加速工具': 'bac-icon-web-speed-up',
};

export const NOTICE_SCENE_NAME_MAP = {
    waitingFeedBack: i18n.t('dai-nin-fan-kui'),
    waitConfirm: i18n.t('dai-nin-que-ren'),
    autoClose: i18n.t('zi-dong-guan-dan-yu-jing'),
    tsReply: i18n.t('gong-cheng-shi-hui-fu'),
};

export const TIMES = {
    ANY_TIME: i18n.t('ren-yi-shi-jian'),
    WORK_TIME: '9:00-18:00',
    REFUSED: i18n.t('bu-xi-wang-lian-xi'),
};

export const boardConfig = {
    overlayOpacity: 0.5,
    nextBtnText: i18n.t('xia-yi-bu') as string,
    prevBtnText: i18n.t('shang-yi-bu') as string,
    doneBtnText: i18n.t('wo-zhi-dao-le') as string,
    allowClose: true, // 允许关闭
    showProgress: true,
    progressText: '{{current}}/{{total}}',
    stagePadding: 5,
    showButtons: ['next', 'previous', 'close'] as AllowedButtons[],
    onPopoverRender(popover: PopoverDOM) {
        // 强制让arrow居中
        setTimeout(() => {
            if (popover.arrow) {
                popover.arrow.className = popover.arrow.className
                    .replace(/driver-popover-arrow-align-[^\s]+/, 'driver-popover-arrow-align-center');
            }
        }, 30);
        // 去掉默认的关闭按钮的叉号，通过样式控制关闭按钮的样式
        popover.closeButton.innerHTML = '';
    },
};

// 计费模式
export const CHARGE_MODE = {
    ALL: 'ALL', // 全量包
    PART: 'PART', // 续费包
    PACKAGE: 'PACKAGE', // 量包
    STORAGE_PACKAGE: 'STORAGE_PACKAGE', // 存储包
};

// 计费模式列表
export const CHARGE_MODE_LIST = [CHARGE_MODE.ALL, CHARGE_MODE.PART, CHARGE_MODE.PACKAGE, CHARGE_MODE.STORAGE_PACKAGE];


// 计费模式名称映射

export const CHARGE_MODE_NAME_MAP = {
    [CHARGE_MODE.ALL]: '资源全生命周期退订',
    [CHARGE_MODE.PART]: '资源续费周期退订',
    [CHARGE_MODE.PACKAGE]: '量包退订',
    [CHARGE_MODE.STORAGE_PACKAGE]: '存储包退订',
};


/**
 * 判断是否为沙盒环境
 */
export const isSandbox = /bcetest.baidu.com/.test(location.href) || location.host.includes('test');


/**
 * 只随环境变化的常量
 */
export const constant = {
    [isSandbox as any]: {
        // 登录链接
        loginLink: 'https://login.bcetest.baidu.com/?redirect=',
        // 售后域名
        console: 'https://qasandbox.bcetest.baidu.com',
        // 售前留言
        contactUsLink: 'https://cloudtest.baidu.com/survey/connect-us.html',
        // 游客模式验证登录
        veryLogin: 'https://bcetest.baidu.com',
        ticketDomain: 'https://ticket.bcetest.baidu.com',
        // 提交工单
        createTicketLink: 'https://ticket.bcetest.baidu.com/#/ticket/create',
        // 工单详情
        ticketDetail: 'https://ticket.bcetest.baidu.com/#/ticket/detail?ticketId=',
        // 工单新域名
        ticketDomainNew: 'https://qasandbox.bcetest.baidu.com/ticket/',
        createTicketLinkNew: 'https://qasandbox.bcetest.baidu.com/support/#/ticket/#/ticket/create',
        ticketDetailNew: '/ticket/#/ticket/detail?ticketId=',
        // 服务与支持中，工单详情
        supportTicketDetail: 'https://qasandbox.bcetest.baidu.com/support#/ticket/#/ticket/detail?ticketId=',
        // 官网文档
        officalDoc: [
            'https://cloudtest.baidu.com/doc/',
            'https://cloud.baidu.com/doc/',
        ],
        // 退订管理
        refundManage: 'https://qasandbox.bcetest.baidu.com/billing/#/refund/confirm',
        // BCC改配
        changeConfig: 'https://qasandbox.bcetest.baidu.com/bcc/#/bcc/instance/upgrade_config',
        // 签名管理
        signatureLink: 'https://qasandbox.bcetest.baidu.com/smsv3/#/smsv3/gnsignature/list',
        // 模版管理
        templateLink: 'https://qasandbox.bcetest.baidu.com/smsv3/#/smsv3/gntemplate/list',
        // 工具箱
        toolHost: 'https://qasandbox.bcetest.baidu.com/tools',
    },
    [!isSandbox as any]: {
        loginLink: 'https://login.bce.baidu.com/?redirect=',
        console: 'https://console.bce.baidu.com',
        contactUsLink: 'https://cloud.baidu.com/survey/connect-us.html',
        veryLogin: 'https://bce.baidu.com',
        ticketDomain: 'https://ticket.bce.baidu.com',
        createTicketLink: 'https://ticket.bce.baidu.com/#/ticket/create',
        ticketDetail: 'https://ticket.bce.baidu.com/#/ticket/detail?ticketId=',
        ticketDomainNew: 'https://console.bce.baidu.com/ticket/',
        createTicketLinkNew: 'https://console.bce.baidu.com/support/#/ticket/#/ticket/create',
        ticketDetailNew: '/ticket/#/ticket/detail?ticketId=',
        supportTicketDetail: 'https://console.bce.baidu.com/support#/ticket/#/ticket/detail?ticketId=',
        officalDoc: [
            'https://cloud.baidu.com/doc/',
        ],
        refundManage: 'https://console.bce.baidu.com/billing/#/refund/confirm',
        changeConfig: 'https://console.bce.baidu.com/bcc/#/bcc/instance/upgrade_config',
        signatureLink: 'https://console.bce.baidu.com/smsv3/#/smsv3/gnsignature/list',
        templateLink: 'https://console.bce.baidu.com/smsv3/#/smsv3/gntemplate/list',
        toolHost: 'https://console.bce.baidu.com/tools',
    },
};
